import {
    FETCH_SERVICE_TYPES_SUCCESS,
    FETCH_SERVICE_TYPES_BY_ID_SUCCESS,

    SERVICE_TYPES_REQUEST_LOADING,
    SERVICE_TYPES_REQUEST_ERRORS
} from "api/menu/master-files/service-types/actions";

const initialState = {
    loading: false,
    errors: [],

    serviceTypes: [],
    singleServiceType: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SERVICE_TYPES_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case SERVICE_TYPES_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_SERVICE_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                serviceTypes: action.payload
            };
        case FETCH_SERVICE_TYPES_BY_ID_SUCCESS:
            return {
                ...state,
                errors: [],
                loading: false,
                singleServiceType: action.payload
            };
        default:
            return state;
    }
}
